export default {
  login: {
    title: 'Importer registration for Loire Wines Trade Tasting',
    signIn: 'Se connecter',
    signUp: "S'inscrire",
    forgotPassword: 'Mot de passe oublié?',
    email: 'Email',
    password: 'Mot de passe',
    test: 'Test',
  },
};
